import { type FunctionComponent, useState } from 'react';

import { Link } from '@dr.pogodin/react-utils';

import Table from 'components/Table';

import { AdminPage } from 'components/admin';

import { useUserList } from 'hooks';
import type { UserListSortT } from 'utils';

import { Item } from './Item';

import './style.scss';

export const UsersManagementPage: FunctionComponent = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState<UserListSortT>('REGISTRATION_TIMESTAMP_DESC');

  const list = useUserList({ page, pageSize, sort });

  const numPages = list.data?.pageSize
    ? Math.ceil(list.data.numTotal / list.data.pageSize)
    : 0;

  return (
    <AdminPage
      subTitle="Review members, manage access, and understand community activity"
      title="User management"
    >
      <Table
        busy={list.loading}
        numPages={numPages}
        page={page}
        pageSize={pageSize}
        pageSizeOptions={[10, 50, 100]}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        <thead>
          <tr>
            <th>User</th>
            <th>
              <Link
                onClick={() => {
                  setSort(
                    sort === 'REGISTRATION_TIMESTAMP_DESC'
                      ? 'REGISTRATION_TIMESTAMP_ASC'
                      : 'REGISTRATION_TIMESTAMP_DESC',
                  );
                }}
                styleName="nolink"
                to=""
              >
                Joined
                {sort === 'REGISTRATION_TIMESTAMP_ASC' ? '▲' : null}
                {sort === 'REGISTRATION_TIMESTAMP_DESC' ? '▼' : null}
              </Link>
            </th>
            <th>
              <Link
                onClick={() => {
                  setSort(
                    sort === 'LAST_SEEN_DESC'
                      ? 'LAST_SEEN_ASC'
                      : 'LAST_SEEN_DESC',
                  );
                }}
                styleName="nolink"
                to=""
              >
                Activity
                {sort === 'LAST_SEEN_ASC' ? '▲' : null}
                {sort === 'LAST_SEEN_DESC' ? '▼' : null}
              </Link>
            </th>
          </tr>
        </thead>
        <tbody>
          {list.data?.users.map(
            (user) => <Item key={user.id} user={user} />,
          )}
        </tbody>
      </Table>
    </AdminPage>
  );
};
